import { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useRouter } from "src/hooks/useRouter";
import {
  checkServiceId,
  createServiceSite,
  getCashUserStatus,
} from "src/service/pay";
import { localStrings } from "src/utils/localization";
import { notifyError, notifySuccess } from "src/components/Common/Toast";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import {
  maxLengthValidation,
  urlNameValidation,
  urlValidation,
} from "src/utils/validation";
import "./SiteNew.style.scss";
import { useRecoilState } from "recoil";
import { productKeyAtom, userInfoAtom } from "src/atoms";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";
import IconTooltip from "components/Common/IconTooltip";
import { useShowSiteUrl } from "src/hooks/recoil/useShowSiteUrl";
import { useQueryClient } from "react-query";
import { useIsDspProduct } from "src/hooks/recoil/useIsDspProduct";
import { useIsFiresideProduct } from "src/hooks/recoil/useFiresideProduct";
import { useIsWrapsodyEcoProduct } from "src/hooks/recoil/useIsWrapsodyEcoProduct";
import { useIsWrapsodyProduct } from "src/hooks/recoil/useIsWrapsodyProduct";
import { ICheckServiceIdReq } from "src/service/types/pay.type";
import { useTranslation } from "react-i18next";

interface ISiteNewModalProps {
  showSiteNewModal: boolean;
  // type: string;
  // setType: any;
  serviceBillUid: string;
  // setCode: any;
  hideModal: () => void;
}
const SiteNewModal = ({
  showSiteNewModal,
  serviceBillUid,
  hideModal,
}: ISiteNewModalProps) => {
  // const [type, setType] = useState<string>("");
  // const [code, setCode] = useState<string>("");
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);
  const [referralId, setReferralId] = useState<string>("");
  const [serviceName, setServiceName] = useState<string>("");
  const [serviceId, setServiceId] = useState<string>("");
  const [serviceIdChecked, setServiceIdChecked] = useState<string>("");
  const route = useRouter();
  const [regionId, setRegionId] = useState<string>(
    route.lang === "ko" ? "ap-northeast-2" : "us-east-1"
  );
  const [isServiceName, setIsServiceName] = useState<boolean>(false);
  const [isServiceId, setIsServiceId] = useState<boolean>(false);
  const [isDuplicateId, setIsDuplicateId] = useState<boolean>(false);
  const [makeServiceLoading, setMakeServiceLoading] = useState<boolean>(false);

  const { isOciProduct } = useIsOciProduct();
  const { isDspProduct } = useIsDspProduct();
  const { isWrapsody } = useIsWrapsodyProduct();
  const { isWrapsodyEco } = useIsWrapsodyEcoProduct();
  const { isFiresideProduct } = useIsFiresideProduct();
  const isShowSiteUrl = useShowSiteUrl();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const makeService = async () => {
    try {
      // this.commonStore.setLoading(true)
      setMakeServiceLoading(false);
      try {
        // 사이트 생성 (기존)
        const createSiteReq = {
          urlPrefix: serviceId,
          product: getProductFromSessionStorage(),
          // product: 'WRAPSODY_ECO',
          region: regionId,
          serviceName: serviceName,
          serviceBillUid: serviceBillUid, // 실제 사이트 생성할때 잘 들어가는지 확인
          cloudProvider: isOciProduct || isFiresideProduct ? "OCI" : "AWS",
        };
        // 테넌시 생성 (New)
        const createTenancyReq = {
          urlPrefix: serviceId,
          product: getProductFromSessionStorage(),
          // product: 'WRAPSODY_ECO',
          region: regionId,
          serviceName: serviceName,
          serviceBillUid: serviceBillUid, // 실제 사이트 생성할때 잘 들어가는지 확인
        };
        // console.log("siteRequest", siteRequest);
        setMakeServiceLoading(true);
        const siteResult = await createServiceSite({ ...createSiteReq });

        if (siteResult) {
          setMakeServiceLoading(false);
          // notifySuccess(
          //   t("siteManagement.createSite.createStatusStart")
          // );
          // route.goConsole();
          if (isOciProduct) {
            alert(t("siteManagement.createSite.createStatusComplete"));
            if (productKey === "WRAPSODY") route.productReload({ productKey });
            else if (productKey === "WRAPSODY_ECO")
              // route.productReload({ productKey, urlPrefix: serviceName });
              route.productReload({ productKey, urlPrefix: serviceId });
          } else {
            alert(t("siteManagement.createSite.createStatusStart"));
            route.goConsole();
            queryClient.clear();
            route.reload();
          }
        }
      } catch (error: any) {
        if (error?.errorCode && error?.errorMessage) {
          notifyError(error.errorMessage);

          const checkCashStatus = await getCashUserStatus({
            product: [getProductFromSessionStorage()],
          });
          if (!["APPROVED", "DONE"].includes(checkCashStatus.status)) {
            route.goSiteType();
          }
        }
      }
      // this.commonStore.setLoading(false)
    } catch (error: any) {
      if (error?.errorCode && error?.errorMessage) {
        notifyError(error.errorMessage);
      }
    }
  };

  const handleChange = async (e: any) => {
    if (e.target.name === "serviceName") {
      const tempValue = e.target.value;
      if (tempValue !== "" && maxLengthValidation(tempValue, 50)) {
        setIsServiceName(true);
      } else {
        setIsServiceName(false);
      }
      setServiceName(tempValue);
    } else if (e.target.name === "serviceId") {
      // let serviceIdChecked = "";
      // let isServiceId = false;
      const tempValue = e.target.value;
      // if (tempValue !== "" && urlNameValidation(tempValue)) {
      if (tempValue !== "") {
        try {
          const baseRequest: ICheckServiceIdReq = {
            urlPrefix: tempValue,
            product: getProductFromSessionStorage(),
            serviceBillUid: serviceBillUid,
          };
          // 랩소디, 에코일때만 cloudProvider 추가
          if (isWrapsody || isWrapsodyEco) {
            baseRequest.cloudProvider = isOciProduct ? "OCI" : "AWS";
          }
          const result = await checkServiceId(baseRequest);
          if (result && urlNameValidation(tempValue)) {
            if (!result.errorCode) {
              setServiceIdChecked(tempValue);
              setIsServiceId(true);
            } else {
              setServiceIdChecked("");
              setIsServiceId(false);
            }
          } else {
            setServiceIdChecked("");
            setIsServiceId(false);
          }
          setIsDuplicateId(false);
        } catch (error: any) {
          console.log("error", error?.message);
          if (error?.message === "DUPLICATE_DATA") {
            // 중복된 service ID 값 있을때 (URL / ID)
            setIsDuplicateId(true);
            setIsServiceId(false);
          } else {
            setServiceIdChecked("");
            setIsServiceId(false);
            setIsDuplicateId(false);
          }
        }
      } else {
        setServiceIdChecked("");
        setIsServiceId(false);
      }
      setServiceId(tempValue);
    } else if (e.target.name === "regionId") {
      setRegionId(e.target.value);
    }
  };

  return (
    <Modal
      show={showSiteNewModal}
      backdrop="static"
      onHide={hideModal}
      className="siteNewModal"
      style={{ opacity: 1 }}
    >
      <Modal.Header>
        <div className="header">
          <h3>{t("siteManagement.createSiteModal.title")}</h3>
          <div className="exit">
            <a onClick={hideModal}>
              <i className="icon_cancel" />
            </a>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>
          {/* {isLoading ? <Loading /> : ''} */}
          <div className="siteNew">
            <form className="form">
              <div className="form-item">
                <div className="flex-column justify-start">
                  <span className="form-item-title flex-row">
                    {t(
                      `siteManagement.createSiteModal.${
                        isShowSiteUrl ? "siteUrl" : "siteId"
                      }`
                    )}
                    <span style={{ color: "red", marginLeft: 2 }}>*</span>
                    {/* {isShowSiteUrl && ( */}
                    <span style={{ marginLeft: 5 }}>
                      <IconTooltip
                        iconType="question"
                        iconColor="question"
                        isShowCard={false}
                        innerWidth={`${isShowSiteUrl ? "140px" : "300px"}`}
                      >
                        {t(
                          `siteManagement.createSiteModal.tooltip.${
                            isShowSiteUrl ? "siteUrl" : "siteId"
                          }`
                        )}
                      </IconTooltip>
                    </span>
                    {/* )} */}
                  </span>
                  <div
                    className={`flex align-center ${
                      isOciProduct &&
                      productKey === "WRAPSODY_ECO" &&
                      "flex-row-reverse"
                    }`}
                  >
                    <div className="w-100">
                      <input
                        type="text"
                        id="serviceId"
                        name="serviceId"
                        title={t(
                          `siteManagement.createSiteModal.${
                            isShowSiteUrl ? "siteUrl" : "siteId"
                          }`
                        )}
                        // placeholder="사이트 생성을 위한 ID를 입력하세요."
                        defaultValue={serviceId}
                        autoFocus={false}
                        onChange={handleChange}
                        placeholder={
                          !isShowSiteUrl
                            ? t(
                                `siteManagement.createSiteModal.placeholder.siteId`
                              )
                            : ""
                        }
                        maxLength={15}
                        className="form-control custom-form width"
                        // className="form-control custom-form width w-247"
                      />
                    </div>
                    {isShowSiteUrl && (
                      <div className="mg mb-12">
                        <span className="text text--black">
                          {isOciProduct && productKey === "WRAPSODY_ECO"
                            ? t(`siteManagement.createSiteModal.suffix.ociEco`)
                            : isDspProduct
                            ? ".fasoodsp.com"
                            : t(
                                `siteManagement.createSiteModal.suffix.${
                                  productKey === "WRAPSODY" ? "wrapsody" : "eco"
                                }`
                              )}
                          {/* {window.sessionStorage.getItem("product") ===
                          "WRAPSODY_ECO"
                            ? t(
                                `siteManagement.createSiteModal.suffix.eco`
                              )
                            : t(
                                `siteManagement.createSiteModal.suffix.wrapsody`
                              )} */}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="warrningText">
                <div>
                  {serviceId === "" && !isServiceId ? (
                    ""
                  ) : isServiceId && maxLengthValidation(serviceId, 15) ? (
                    <span className="text text--green">
                      {t(
                        `siteManagement.createSiteModal.alert.${
                          isShowSiteUrl ? "validAddress" : "validId"
                        }`
                      )}
                    </span>
                  ) : (
                    <>
                      {!urlValidation(serviceId) ? (
                        <span className="text text--orange">
                          {t(
                            `siteManagement.createSiteModal.alert.${
                              isDuplicateId
                                ? "isDuplicate"
                                : isShowSiteUrl
                                ? "invalidAddress"
                                : "invalidId"
                            }`
                          )}
                        </span>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </div>
              </div>
              {/* 사이트 이름 */}
              <div className="form-item">
                <span className="form-item-title ">
                  {t("siteManagement.createSiteModal.siteName")}
                  <span style={{ color: "red", marginLeft: 2 }}>*</span>
                </span>
                <input
                  type="text"
                  id="serviceName"
                  name="serviceName"
                  title={t("siteManagement.createSiteModal.siteName")}
                  value={serviceName}
                  onChange={handleChange}
                  maxLength={128}
                  placeholder={t(
                    `siteManagement.createSiteModal.placeholder.siteName`
                  )}
                  className={`form-control custom-form width 370`}
                />
              </div>
              {!isServiceName && serviceName !== "" ? (
                <div className="warrningText">
                  <span className="text text--orange">
                    {t("siteManagement.createSiteModal.siteNameCheckMsg", {
                      0: 50,
                    })}
                  </span>
                </div>
              ) : (
                ""
              )}
              {/* <div className="form-item">
                <span className="form-item-title">
                  {t("siteType.manager")}
                </span>
                <input
                  type="text"
                  id="serviceName"
                  name="serviceName"
                  title={t(
                    "siteManagement.createSiteModal.siteName"
                  )}
                  value={serviceName}
                  onChange={handleChange}
                  maxLength={128}
                  className="form-control custom-form width w-370"
                />
              </div> */}
              {/* <div className="form-item">
                <span className="form-item-title">
                  {t("siteType.free.detail.phoneNumber")}
                </span>
                <input
                  type="text"
                  id="serviceName"
                  name="serviceName"
                  title={t(
                    "siteManagement.createSiteModal.siteName"
                  )}
                  value={serviceName}
                  onChange={handleChange}
                  maxLength={128}
                  className="form-control custom-form width w-370"
                />
              </div> */}
              {!isDspProduct && !isFiresideProduct && (
                <div
                  className="form-item"
                  style={{ display: isOciProduct ? "none" : "block" }}
                >
                  <span className="form-item-title">
                    {t(
                      "siteManagement.createSiteModal.serverLocation.fieldname"
                    )}
                  </span>
                  <select
                    name="regionId"
                    value={regionId}
                    onChange={handleChange}
                    className="form-control custom-form width w-370"
                  >
                    <option value="ap-northeast-2">
                      {t(
                        "siteManagement.createSiteModal.serverLocation.option_1"
                      )}
                    </option>
                    <option value="us-east-1">
                      {t(
                        "siteManagement.createSiteModal.serverLocation.option_2"
                      )}
                    </option>
                  </select>
                </div>
              )}
            </form>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          // type="button"
          variant="secondary"
          className="btn btn-gray btn-36 width min-w-66"
          onClick={hideModal}
        >
          {t("common.cancelBtn")}
        </Button>
        <Button
          // type="button"
          variant="primary"
          disabled={!isServiceName || !isServiceId || makeServiceLoading}
          onClick={makeService}
          className="btn btn-green btn-36 width min-w-66"
        >
          {makeServiceLoading && (
            <Spinner animation="border" role="status" size="sm" />
          )}
          {t("common.okBtn")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SiteNewModal;
